// Fine del caricamento di una tabella: le righe arrivate compaiono con una
// dissolvenza breve, sfalsata dall'alto come l'onda delle righe finte
// (TableSkeleton), invece di sostituirle di colpo. Animazione in
// _tables.scss (.is-revealing); con "riduci movimento" non c'è.
const REVEAL_MS = 700;

export const revealRows = (el) => {
  const table = el?.querySelector?.("table.b-table");
  if (!table) return;
  clearTimeout(table.revealTimer);
  table.classList.remove("is-revealing");
  // Rilegge il layout perché l'animazione riparta anche se la classe c'era.
  void table.offsetWidth;
  table.classList.add("is-revealing");
  table.revealTimer = setTimeout(
    () => table.classList.remove("is-revealing"),
    REVEAL_MS,
  );
};
